import { ShoppingCartIcon } from '@heroicons/react/24/outline';
import Button from '@/components/atoms/button';
import { useTranslations } from 'use-intl';
import Link from '@/components/atoms/link';
import LoadingIcon from '@/components/atoms/loading-icon';

const EmptyCart = ({ loading, browseProductsHref = '/' }: { loading?: boolean; browseProductsHref?: string }) => {
  const translate = useTranslations();

  if (loading)
    return (
      <div className="flex w-full justify-center p-12">
        <LoadingIcon svgWidth={20} svgHeight={20} className="fill-gray-700" />
      </div>
    );

  return (
    <div className="flex flex-col items-center gap-6 p-12 text-center">
      <ShoppingCartIcon className="h-24 w-24 text-gray-300" aria-hidden />
      <div className="flex flex-col gap-2">
        <p className="text-24 font-bold text-gray-800">{translate('cart.empty')}</p>
        <p className="text-16 text-gray-600">{translate('cart.empty-body')}</p>
      </div>
      <Link href={browseProductsHref} underlineOnHover={false}>
        <Button size="l">{translate('cart.browse-products')}</Button>
      </Link>
    </div>
  );
};

export default EmptyCart;
